import { createSlice } from '@reduxjs/toolkit';

import type {
  CloseUps,
  CloseUpButton,
  ToggleCloseUp,
  CloseUpAsset,
} from '@/types';

export interface CloseUpState {
  closeUps: CloseUps;
  toggleCloseUp: ToggleCloseUp;
  closeUpMultiPolygon: number[];
}

const initialState: CloseUpState = {
  closeUps: {},
  toggleCloseUp: {
    closeUpPolygon: [
      [0, 0],
      [0, 0],
    ],
  },
  closeUpMultiPolygon: [],
};

export const closeUpSlice = createSlice({
  name: 'closeUp',
  initialState,
  reducers: {
    setCloseUpInfo: (state, { payload }) => {
      const assetType = payload.assetType;
      const classification = assetType.attributes.classification;
      if (classification === 'closeUp') {
        const assetTypeId = assetType.id;
        const name = assetType.name;
        const mapType = assetType.attributes.mapType;
        const imageUrl = assetType.attributes.images[0].url;
        const closeUps = state.closeUps;
        const closeUpButtons: CloseUpButton[] = [];
        const closeUp = {
          name,
          mapType,
          imageUrl,
          closeUpButtons,
        };
        closeUps[assetTypeId] = closeUp;
      }
    },
    setCloseUpButtonInfo: (state, { payload }) => {
      const closeUpButtons = state.closeUps;
      payload.forEach((closeUpButton: CloseUpAsset) => {
        const name = closeUpButton.name;
        const location = closeUpButton.location;
        const imageUrl = closeUpButton.attributes.images[0].url;
        const color = closeUpButton.attributes.imageColor;
        closeUpButtons[closeUpButton.assetTypeId].closeUpButtons.push({
          name,
          imageUrl,
          location,
          color,
        });
      });
    },
    setToggleCloseUp: (state, { payload }) => {
      const closeUpPolygon = Array.isArray(payload) ? payload : [];
      const southWest = Array.isArray(closeUpPolygon[0])
        ? closeUpPolygon[0]
        : [0, 0];
      const northEast = Array.isArray(closeUpPolygon[1])
        ? closeUpPolygon[1]
        : [0, 0];

      // 同一座標の再押下でも map 側 effect が確実に発火するよう、
      // 毎回新しい配列参照で保持する。
      state.toggleCloseUp.closeUpPolygon = [
        [...southWest],
        [...northEast],
      ];
    },
    setCloseUpMultiPolygon: (state, { payload }) => {
      state.closeUpMultiPolygon = payload;
    },
    resetToggleCloseUp: (state) => {
      state.toggleCloseUp.closeUpPolygon = [
        [0, 0],
        [0, 0],
      ];
    },
  },
});

export const {
  reducer: closeUpReducer,
  actions: {
    setCloseUpInfo,
    setCloseUpButtonInfo,
    setToggleCloseUp,
    setCloseUpMultiPolygon,
    resetToggleCloseUp,
  },
} = closeUpSlice;
